import {ReactNode} from 'react';

interface ReviewActionsProps {
  onBack?: () => void;
  onSaveDraft?: () => void;
  onPrimary?: () => void;
  saveDraftLabel?: string;
  primaryLabel?: string;
  primaryLoadingLabel?: string;
  isSavingDraft?: boolean;
  isSavingPrimary?: boolean;
  primaryDisabled?: boolean;
}

const actionButtonBase =
  'inline-flex h-11 items-center justify-center overflow-hidden rounded-[10px] px-4 py-2.5 text-sm font-medium leading-[22px] transition-colors focus:outline-none focus:ring-4 focus:ring-purple200 disabled:cursor-not-allowed';

const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
}: {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={`${actionButtonBase} border border-borderDark bg-white text-blackTwo hover:border-purple300 hover:text-purple300 disabled:text-textMuted`}>
    {children}
  </button>
);

export const ReviewActions = ({
  onBack,
  onSaveDraft,
  onPrimary,
  saveDraftLabel = 'Save as draft',
  primaryLabel = 'Launch check-in',
  primaryLoadingLabel = 'Saving...',
  isSavingDraft = false,
  isSavingPrimary = false,
  primaryDisabled = false,
}: ReviewActionsProps) => (
  <footer className="mt-2 flex min-h-[50px] w-full flex-row flex-wrap items-center justify-between gap-3">
    <SecondaryButton onClick={onBack}>
      <span className="flex items-center gap-2.5">
        <svg
          aria-hidden="true"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none">
          <path
            d="M14.001 8H2.668M7.335 12.667L2.668 8l4.667-4.667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Go back
      </span>
    </SecondaryButton>

    {(onSaveDraft || onPrimary) && (
      <div className="flex items-center gap-2">
        {onSaveDraft && (
          <SecondaryButton
            onClick={onSaveDraft}
            disabled={isSavingDraft || isSavingPrimary}>
            {isSavingDraft ? 'Saving...' : saveDraftLabel}
          </SecondaryButton>
        )}
        {onPrimary && (
          <button
            type="button"
            aria-busy={isSavingPrimary}
            disabled={isSavingDraft || isSavingPrimary || primaryDisabled}
            onClick={onPrimary}
            className={`${actionButtonBase} border border-purple300 bg-purple300 text-alwaysWhite hover:border-warmBlue hover:bg-warmBlue ${
              isSavingPrimary
                ? 'disabled:border-purple300 disabled:bg-purple300 disabled:text-alwaysWhite'
                : 'disabled:border-backgroundDark disabled:bg-backgroundDark disabled:text-textMuted'
            }`}>
            {isSavingPrimary ? primaryLoadingLabel : primaryLabel}
          </button>
        )}
      </div>
    )}
  </footer>
);
